import { createContext, useContext } from 'react';

import type { ApolloQueryResult } from 'apollo-client';

import type {
  GetSkillAttainmentByOccupationGroupAndCareerBandQuery as QueryResult,
  GetSkillAttainmentByOccupationGroupAndCareerBandQueryVariables as QueryVariables,
  SkillAttainmentSkillAreaAttainmentFragment,
} from 'bundles/skills-common/shared/verified-skills/data/skill-pathway/__generated__/GetSkillAttainmentByOccupationGroupAndCareerBandQuery';

export type SkillPathwayAttainmentsData = {
  skillAttainments?: SkillAttainmentSkillAreaAttainmentFragment[] | null;
  refetchSkillAttainments?: (variables?: QueryVariables) => Promise<ApolloQueryResult<QueryResult>>;
  loading: boolean;
};

const SkillPathwayAttainmentsDataContext = createContext<SkillPathwayAttainmentsData>({
  skillAttainments: [],
  loading: false,
});

export const useSkillPathwayAttainmentsDataContext = (): SkillPathwayAttainmentsData => {
  const context = useContext(SkillPathwayAttainmentsDataContext);

  if (!context) {
    throw new Error('useSkillPathwayAttainmentsDataContext must be used within a SkillPathwayAttainmentsDataProvider');
  }

  return context;
};

export default SkillPathwayAttainmentsDataContext;
